import { render } from "./App.vue?vue&type=template&id=6e52defc&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6e52defc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/megaluzz-client/megaluzz-client/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e52defc"]])

export default __exports__